import Vue from 'vue';
import Vuex from 'vuex';
import {baseURL} from "@/mixins/helpers";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        members: null,
        boards: null,
        token: null,
        userID: null,
        currentUser: null,
        tagFilter: 'no-filter',
        userFilter: 'no-filter',
        smartListFilter: 'no-filter',
        smartListTagFilter: ['no-filter'],
        tasks: null,
        editableTask: null,
        templateTasks: [{
            title: 'New "Empty Task"',
            body: '',
            tags: []
        }],
        events: null,
        events2: [],
        activeBoard: null,
        activeBoardTasks: null,
        users: null,
        recordingInfo: null,
        isTaskEditing: false,
        isCommenting: false,
        uploadingInProcess: null,
        recordingLimit: 2,
        taskTimeTracker: null,
        tags: null,
        theme: 'theme-dark',
        themes: [{
            name: 'theme-dark',
            title: 'Dark',
            styles: `background-color: #000;`
        }, {
            name: 'theme-light',
            title: 'Light',
            styles: `background: #fff;`
        }],
        backgroundColor: '#192536',
        backgrounds: [{
            name: 'gradient-1',
            styles: 'linear-gradient(180deg, #122631 0%, #1D5B7D 100%)',
            type: 'gradient'
        }, {
            name: 'gradient-2',
            styles: 'linear-gradient(126.11deg, #202940 0.76%, rgba(43, 50, 68, 0.5) 71.65%)',
            type: 'gradient'
        }, {
            name: 'gradient-3',
            styles: 'linear-gradient(126.11deg, #286E96 0.76%, #4E7C69 71.65%)',
            type: 'gradient'
        }, {
            name: 'gradient-4',
            styles: 'linear-gradient(126.11deg, #2E263B 0.76%, #4098D8 71.65%)',
            type: 'gradient'
        }, {
            name: 'gradient-5',
            styles: 'linear-gradient(126.11deg, #6A42BF 0.76%, #B39DE2 71.65%)',
            type: 'gradient'
        },{
            name: 'gradient-6',
            styles: 'linear-gradient(126.24deg, #192536 0%, rgba(25, 37, 54, 0.82) 71.15%)',
            type: 'gradient'
        }, {
            name: 'gradient-7',
            styles: 'linear-gradient(125.21deg, #353D46 1.54%, rgba(53, 61, 70, 0.7) 70.69%)',
            type: 'gradient'
        }, {
            name: 'gradient-8',
            styles: 'linear-gradient(126.24deg, #1D2C54 0%, rgba(29, 44, 84, 0.74) 71.15%)',
            type: 'gradient'
        }, {
            name: 'color-1',
            styles: '#1D5B7D',
            type: 'color'
        }, {
            name: 'color-2',
            styles: '#818394',
            type: 'color'
        }, {
            name: 'color-3',
            styles: '#4C7B6C',
            type: 'color'
        }, {
            name: 'color-4',
            styles: '#396490',
            type: 'color'
        }, {
            name: 'color-5',
            styles: '#7F61AE',
            type: 'color'
        }, {
            name: 'color-6',
            styles: '#192536',
            type: 'color'
        }, {
            name: 'color-7',
            styles: '#353D46',
            type: 'color'
        }, {
            name: 'color-8',
            styles: '#1D2C54',
            type: 'color'
        }],
        activitiesSelectedBoard: null,
        isRecording: false,
        planLimit: null,
        billingPlans: [
            {
                'title': 'Free',
                'name': 'Free',
                'price': 0,
                'gb': 1,
                'projects': 5,
                'members': 5,
                'tasks': 300,
                'rec_time': 2,
                'draw_images': true,
                'show_plan': true
            },
            {
                'title': 'Trial',
                'name': 'Trial',
                'price': 0,
                'gb': 200,
                'projects': 20,
                'members': 20,
                'tasks': 1000,
                'rec_time': 10,
                'draw_images': true,
                'show_plan': true
            },
            {
                'title': 'Premium',
                'name': 'Pro',
                'price': 39,
                'gb': 200,
                'projects': 20,
                'members': 20,
                'tasks': 1000,
                'rec_time': 10,
                'draw_images': true,
                'show_plan': true
            },
            {
                'title': 'Corporate',
                'name': 'Corporate',
                'price': 199,
                'gb': 2000,
                'projects': 200,
                'members': 200,
                'tasks': 'Unlimited',
                'rec_time': 20,
                'draw_images': true,
                'show_plan': true
            },
            {
                'title': 'AppSumo',
                'name': 'AppSumo',
                'price': 0,
                'gb': 10,
                'projects': 7,
                'members': 7,
                'tasks': 1000,
                'rec_time': 5,
                'draw_images': true,
                'show_plan': false
            },
        ],
        importCSVTasks: null,
        smartListTasks: [],
        timeTrackerTasks: [],
        activitiesTasks: []
    },
    mutations: {
        setBoards(state, boards) {
            state.boards = boards
        },
        setTags(state, tags) {
            state.tags = tags
        },
        addTag(state, tag) {
            state.tags.push(tag)
        },
        setBackgroundColor(state, color) {
            state.backgroundColor = color
        },
        editBoard(state, board) {
            state.boards.forEach((b, i) => {
                if(b.id == board.id) {
                    state.boards[i] = board
                }
            })
        },
        removeList(state, listID) {
            state.activeBoardTasks.forEach((list, i, arr) => {
                list.tasks.forEach(taskItem => {
                    if (taskItem.id == state.editableTask?.id && state.isTaskEditing) {
                        taskItem['body'] = state.editableTask['body']
                    }
                })

                if(list.id == listID) {
                    arr.splice(i, 1)
                }
            })
        },
        switchBoardLists(state, data) {
            let board = state.activeBoardTasks
            let listIndex = board.findIndex(l => l.id == data.list_id)
            let prevListIndex = board.findIndex(l => l.id == data.prev_list_id)
            let element = board[listIndex];

            if(listIndex > prevListIndex) {
                prevListIndex++
            }

            state.activeBoardTasks.splice(listIndex, 1);
            state.activeBoardTasks.splice(prevListIndex, 0, element);

            state.activeBoardTasks.forEach(list => list.tasks.forEach(taskItem => {
                if (taskItem.id == state.editableTask?.id && state.isTaskEditing) taskItem['body'] = state.editableTask['body']
            }))
        },
        auth(state, data) {
            state.token = data.token;
            state.userID = data.user.id;
            state.currentUser = data.user;
        },
        setCurrentUser(state, user) {
            //if (user.portrait) user.portrait = `${baseURL()}${user?.portrait}`
            state.currentUser = user;
        },
        setUserFilter(state, tag) {
            state.userFilter = tag;
        },
        setTagFilter(state, tag) {
            state.tagFilter = tag;
        },
        setRecordingInfo(state, info) {
            state.recordingInfo = info;
        },
        setSmartListFilter(state, tag) {
            state.smartListFilter = tag;
        },
        setSmartListTagFilter(state, tag) {
            state.smartListTagFilter = tag;
        },
        setTaskTimeTracker(state, time) {
            state.taskTimeTracker = time;
        },
        setEditableTask(state, task) {
            state.editableTask = task;
        },
        setTemplateTasks(state, tasks) {
            let existingTasks = state.templateTasks.map(t => t.id).filter(t => t)
            tasks.forEach(t => {
                if(!existingTasks.includes(t.id)) {
                    state.templateTasks.unshift(t)
                }
            })
        },
        toggleTemplateTask(state, task) {
            let existingTasks = state.templateTasks.map(t => t.id)
            if(existingTasks.includes(task.id)) {
                let i = existingTasks.indexOf(task.id)
                state.templateTasks.splice(i, 1)
            } else {
                state.templateTasks.unshift(task);
            }
        },
        editTemplateTask(state, newTaskData) {
            state.templateTasks.forEach((t, i) => {
                if(t.id == newTaskData.id) {
                    state.templateTasks[i] = newTaskData
                }
            })
        },
        resetTemplateTask(state) {
            state.templateTasks = [{
                title: 'Empty Task',
                body: '',
                tags: []
            }]
        },
        addEvents2(state, data) {
            let events = [...state.events2]
            events.push(data)

            //checks if events are duplicated
            const seenIds = new Set();
            state.events2 = events.filter(event => {
                if (seenIds.has(event.id)) {
                    return false;
                } else {
                    seenIds.add(event.id);
                    return true;
                }
            });
        },
        editTask(state, newTaskData) {
            state.activeBoardTasks?.forEach(list => {
                list.tasks.forEach(taskItem => {
                    //?
                    if (taskItem.id == state.editableTask?.id && state.isTaskEditing) {
                        taskItem['body'] = state.editableTask['body']
                    }
                    
                    if(taskItem.id == newTaskData.id) {
                        taskItem = Object.assign(taskItem, newTaskData)
                    }
                })
            })

            if(state.editableTask?.id == newTaskData.id) {
                state.editableTask = newTaskData;
            }

            state.smartListTasks?.forEach((list, i, arr) => {
                list.tasks.forEach((task, j, tasks) => {
                    if(task.id == newTaskData.id) {
                        tasks[j] = Object.assign(task, newTaskData)
                    }
                })
            })

            state.timeTrackerTasks?.forEach((item) => {
                item.times?.forEach((time, j, times) => {
                    time?.forEach((timeItem, k, timeList) => {
                        if(timeItem.task.id == newTaskData.id) {
                            timeItem.task.title = newTaskData.title
                        }
                    })
                })
            })

            state.activitiesTasks?.forEach((event, i, arr) => {
                if(event.task_id == newTaskData.id) {
                    arr[i].task_title = newTaskData.title
                }
            });
        },
        editTaskEvents(state, event) {
            let listIndex = state.activeBoardTasks?.findIndex(l => l.id == event.list_id)
                
            if(state.editableTask?.id == event.task_id) {
                console.log(state.editableTask)
                if(!state.editableTask['events']) {
                    state.editableTask['events'] = []
                }
                state.editableTask['events'].unshift(event);
            }
            
            if(!listIndex) return

            state.activeBoardTasks[listIndex]?.tasks.forEach((task, i, arr) => {
                if(task.id == event.task_id) {
                    if(!arr[i]['events']) {
                        arr[i]['events'] = []
                    }
                    arr[i]['events'].unshift(event);
                }
            })
        },
        editTaskListId(state, task) {

        },
        setActiveBoard(state, boardID) {
            state.activeBoard = state.boards?.find(b => {
                return b.id == boardID
            });
        },
        setActiveBoardTasks(state, data) {
            state.activeBoardTasks = data
        },
        addActiveBoardList(state, list) {
            state.activeBoardTasks.push(list)

            state.activeBoardTasks.forEach(list => list.tasks.forEach(taskItem => {
                if (taskItem.id == state.editableTask?.id && state.isTaskEditing) taskItem['body'] = state.editableTask['body']
            }))
        },
        editActiveBoardList(state, data) {
            state.activeBoardTasks.forEach((list, i) => {
                if(list.id == data.id) {
                    state.activeBoardTasks[i] = Object.assign(list, data)
                }

                list.tasks.forEach(taskItem => {
                    if (taskItem.id == state.editableTask?.id && state.isTaskEditing) taskItem['body'] = state.editableTask['body']
                })
            })
        },
        addActiveBoardTask(state, task) {
            state.activeBoardTasks.forEach(list => {
                if(list.id == task.list_id) {
                    list.tasks.push(task)
                }

                list.tasks.forEach(taskItem => {
                    if (taskItem.id == state.editableTask?.id && state.isTaskEditing) {
                        taskItem['body'] = state.editableTask['body']
                    }
                })
            })
        },
        removeActiveBoardTask(state, task) {
            state.activeBoardTasks.forEach(list => {
                if(list.id == task.list_id && list.tasks.findIndex(t => t.id == task.id) >= 0) {
                    list.tasks.splice(list.tasks.findIndex(t => t.id == task.id), 1)
                }
            })
        },
        moveActiveBoardTask(state, data) {
            let currentList = null
            let task = null
            let newList = null;
            let currentPrevTaskId = null

            state.activeBoardTasks.forEach(l => {
                if(l.id == data.list_id) newList = l
                l.tasks.forEach((t, i, tasks) => {
                    if(t.id == data.task_id) {
                        currentList = l
                        task = t
                        currentPrevTaskId = tasks[i - 1] ? tasks[i - 1].id : 0
                    }

                    if (t.id == state.editableTask?.id && state.isTaskEditing) t['body'] = state.editableTask['body']
                })
            })

            if(currentPrevTaskId === data.prev_task_id) return

            let taskIndex = currentList.tasks.findIndex(t => t.id == data.task_id)
            let prevTaskIndex = newList.tasks.findIndex(t => t.id == data.prev_task_id)

            if(currentList.id != newList.id || ((currentList.id == newList.id) && taskIndex > prevTaskIndex)) {
                prevTaskIndex++
            }

            currentList.tasks.splice(taskIndex, 1);
            newList.tasks.splice(prevTaskIndex, 0, task);
            newList.tasks[prevTaskIndex]['list_id'] = data.list_id
        },
        setUsers(state, data) {
            state.users = data
        },
        updateMember(state, data) {
            state.activeBoard?.members.forEach((user, i, arr) => {
                if(user.id == data.user_id) {
                    user.username = data.username
                    user.name = data.name
                    user.portrait = data.portrait
                    user.bio = data.bio
                }
            })
        },
        updateTaskEvent(state, event) {
            state.activeBoardTasks.forEach(list => {
                list.tasks.forEach(taskItem => {
                    if(taskItem.id == event.task_id) {
                        taskItem.events.forEach((e, i, arr) => {
                            if (e.id == event.id) arr[i] = event
                        })
                    }
                })
            })

            state.editableTask?.events.forEach((e, i, arr) => {
                if(e.id == event.id) {
                    arr[i] = event
                }
            })
        },
        deleteTaskEvent(state, event) {
            state.activeBoardTasks?.forEach(list => {
                list.tasks.forEach(taskItem => {
                    if(taskItem.id == event.task_id) {
                        taskItem.events?.forEach((e, i, arr) => {
                            if (e.id == event.id) arr.splice(i, 1);
                        })
                    }
                })
            })

            state.editableTask?.events.forEach((e, i, arr) => {
                if(e.id == event.id) {
                    arr.splice(i, 1);
                }
            })
        },
        setTaskEvents(state, task) {
            let listIndex = state.activeBoardTasks?.findIndex(l => l.id == task.list_id)

            if(state.editableTask?.id == task.id) {
                state.editableTask['events'] = JSON.parse(JSON.stringify(task['events']));
            }
            
            if(!listIndex) return
            state.activeBoardTasks[listIndex]?.tasks.forEach((t, i, arr) => {
                if(t.id == task.id) {
                    arr[i]['events'] = JSON.parse(JSON.stringify(task['events']))
                }
            })
        },
        saveAsTemplateTask(state, task) {
            let listIndex = state.activeBoardTasks.findIndex(l => l.id == task.list_id)
            
            state.activeBoardTasks[listIndex].tasks.forEach((t, i, arr) => {
                if(t.id == task.id) {
                    arr[i]['is_template'] = task['is_template']
                }
            })
        },
        editTaskDescription(state, task) {
            state.activeBoardTasks?.forEach(list => {
                list.tasks.forEach(taskItem => {
                    if(taskItem.id == state.editableTask?.id && state.isTaskEditing) {
                        taskItem['body'] = state.editableTask['body']
                    }
                    
                    if(taskItem.id == task.id) {
                        taskItem['body'] = task['body']
                        taskItem['body_html'] = task['body_html']
                    }

                    if(taskItem.id == task.id && state.editableTask?.id == task.id) {
                        state.editableTask['body'] = taskItem['body'];
                        state.editableTask['body_html'] = taskItem['body_html'];
                    }
                })
            })
        },
        editTaskTags(state, task) {
            state.activeBoardTasks?.forEach((list, l, lists) => {
                list.tasks.forEach((taskItem, t, tasks) => {
                    //?
                    if (taskItem.id == state.editableTask?.id && state.isTaskEditing) {
                        taskItem['body'] = state.editableTask['body']
                    }
                    
                    if(taskItem.id == task.id) {
                        tasks[t]['tags'] = task['tags'].slice()
                    }
                })
            })

            if(state.editableTask?.id == task.id) {
                state.editableTask['tags'] = task['tags'].slice();
            }
        },
        setTaskEditing(state, val) {
            state.isTaskEditing = val
        },
        setCommenting(state, val) {
            state.isCommenting = val
        },
        setUploadingState(state, val) {
            state.uploadingInProcess = val
        },
        formatTaskTags(state, task) {
            //TODO This function is not used yet in the store, but it would be nice to move it here and remove some places in the components
            //In common let use similar functions ones when we receive tasks/users/tags/etc.. and keep it one place, it's easier to control where we're modifying what
            const allUsers = state.boards.flatMap(board => board.members).filter(user => user)
            const usersMap = new Map(allUsers.map(user => [user?.id, user]))
            
            if(typeof task.tags == 'string') {
                task.tags = task.tags.split('|').filter(tag => tag.trim() !== '').map(tag => Number(tag.split(':')[tag.split(':').length - 1])).map(tag => usersMap.get(tag))
            } else if(typeof task.tags == 'array' || (typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'string')) {
                task.tags = task.tags.map(tag => Number(tag.split(':')[tag.split(':').length - 1])).map(tag => usersMap.get(tag))
            } else if(typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'object') {
                task.tags = task.tags
            } else {
                task.tags = []
            }
        },
        setRecordingLimit(state, val) {
            state.recordingLimit = val
        },
        updateCurrentUser(state, data) {
            //if (data.portrait) data.portrait = data.portrait = `${baseURL()}${data?.portrait}`
            state.currentUser = data;

            state.users.forEach((user, i, arr) => {
                if(user.id == data.id) {
                    state.users[i] = Object.assign({}, data)
                }
            })

            state.activeBoard?.members.forEach((user, i, arr) => {
                if(user.id == data.id) {
                    user.username = data.username
                    user.name = data.name
                    user.portrait = data.portrait
                    user.bio = data.bio
                }
            })
        },
        setTheme(state, theme) {
            state.theme = theme
        },
        setActivitiesSelectedBoard(state, board) {
            state.activitiesSelectedBoard = board
        },
        setRecording(state, value) {
            state.isRecording = value
        },
        updatePlanLimit(state, val) {
            state.planLimit = val
        },
        setImportCSV(state, data) {
            state.importCSVTasks = data
        },
        setSmartListTasks(state, tasks) {
            state.smartListTasks = tasks
        },
        setTimeTrackerTasks(state, tasks) {
            state.timeTrackerTasks = tasks
        },
        setActivitiesTasks(state, tasks) {
            state.activitiesTasks = tasks
        }
    },
    actions: {
        setBoards({commit}, boards) {
            commit('setBoards', boards)
        },
        setTags({commit}, tags) {
            commit('setTags', tags)
        },
        addTag({commit}, tag) {
            commit('addTag', tag)
        },
        setBackgroundColor({commit}, color) {
            commit('setBackgroundColor', color)
        },
        editBoard({commit}, board) {
            commit('editBoard', board)
        },
        removeList({commit}, board) {
            commit('removeList', board)
        },
        switchBoardLists({commit}, data) {
            commit('switchBoardLists', data)
        },
        auth({commit}, data) {
            commit('auth', data)
        },
        setCurrentUser({commit}, user) {
            commit('setCurrentUser', user)
        },
        setUserFilter({ commit }, tag) {
            commit('setUserFilter', tag);
        },
        setTagFilter({ commit }, tag) {
            commit('setTagFilter', tag);
        },
        setRecordingInfo({ commit }, tag) {
            commit('setRecordingInfo', tag);
        },
        setSmartListFilter({ commit }, tag) {
            commit('setSmartListFilter', tag);
        },
        setSmartListTagFilter({ commit }, tag) {
            commit('setSmartListTagFilter', tag);
        },
        setTaskTimeTracker({commit}, time) {
            commit('setTaskTimeTracker', time);
        },
        editTask({ commit }, newTaskData) {
            commit('editTask', newTaskData);
        },
        setEditableTask({ commit }, task) {
            commit('setEditableTask', task);
        },
        setTemplateTasks({ commit }, tasks) {
            commit('setTemplateTasks', tasks);
        },
        toggleTemplateTask({ commit }, task) {
            commit('toggleTemplateTask', task);
        },
        editTemplateTask({ commit }, newTaskData) {
            commit('editTemplateTask', newTaskData);
        },
        resetTemplateTask({ commit }) {
            commit('resetTemplateTask');
        },
        addEvents2({ commit }, data) {
            commit('addEvents2', data);
        },
        editTaskEvents({ commit }, event) {
            commit('editTaskEvents', event);
        },
        editTaskListId({ commit }, task) {
            commit('editTaskListId', task);
        },
        setActiveBoard({ commit }, boardID) {
            commit('setActiveBoard', boardID);
        },
        setActiveBoardTasks({ commit }, data) {
            commit('setActiveBoardTasks', data)
        },
        addActiveBoardList({ commit }, list) {
            commit('addActiveBoardList', list)
        },
        addActiveBoardTask({ commit }, task) {
            commit('addActiveBoardTask', task)
        },
        removeActiveBoardTask({ commit }, task) {
            commit('removeActiveBoardTask', task)
        },
        moveActiveBoardTask({ commit }, data) {
            commit('moveActiveBoardTask', data)
        },
        editActiveBoardList({ commit }, data) {
            commit('editActiveBoardList', data)
        },
        setUsers({ commit }, data) {
            commit('setUsers', data)
        },
        updateMember({ commit }, data) {
            commit('updateMember', data)
        },
        updateTaskEvent({ commit }, event) {
            commit('updateTaskEvent', event)
        },
        deleteTaskEvent({ commit }, data) {
            commit('deleteTaskEvent', data)
        },
        setTaskEvents({ commit }, task) {
            commit('setTaskEvents', task)
        },
        saveAsTemplateTask({ commit }, task) {
            commit('saveAsTemplateTask', task)
        },
        editTaskDescription({ commit }, task) {
            commit('editTaskDescription', task)
        },
        editTaskTags({ commit }, task) {
            commit('editTaskTags', task)
        },
        setTaskEditing({ commit }, val) {
            commit('setTaskEditing', val)
        },
        setCommenting({ commit }, val) {
            commit('setCommenting', val)
        },
        setUploadingState({ commit }, val) {
            commit('setUploadingState', val)
        },
        setUploadingFiles({ commit }, data) {
            commit('setUploadingFiles', data)
        },
        setRecordingLimit({ commit }, val) {
            commit('setRecordingLimit', val)
        },
        updateCurrentUser({ commit }, data) {
            commit('updateCurrentUser', data)
        },
        setTheme({ commit }, theme) {
            commit('setTheme', theme)
        },
        setActivitiesSelectedBoard({ commit }, board) {
            commit('setActivitiesSelectedBoard', board)
        },
        setRecording({ commit }, value) {
            commit('setRecording', value)
        },
        updatePlanLimit({ commit }, val) {
            commit('updatePlanLimit', val)
        },
        setImportCSV({ commit }, data) {
            commit('setImportCSV', data)
        },
        setSmartListTasks({ commit }, tasks) {
            commit('setSmartListTasks', tasks)
        },
        setTimeTrackerTasks({ commit }, tasks) {
            commit('setTimeTrackerTasks', tasks)
        },
        setActivitiesTasks({ commit }, tasks) {
            commit('setActivitiesTasks', tasks)
        }
    },
    getters: {
        members: s => s.members,
        boards: s => s.boards,
        userID: s => s.userID,
        currentUser: s => s.currentUser,
        token: s => s.token,
        tasks: s => s.tasks,
        editableTask: s => s.editableTask,
        templateTasks: s => s.templateTasks,
        events: s => s.events,
        events2: s => s.events2,
        activeBoard: s => s.activeBoard,
        activeBoardTasks: s => s.activeBoardTasks,
        users: s => s.users,
        isTaskEditing: s => s.isTaskEditing,
        isCommenting: s => s.isCommenting,
        uploadingInProcess: s => s.uploadingInProcess,
        recordingLimit: s => s.recordingLimit,
        tags: s => s.tags,
        tagFilter: s => s.tagFilter,
        theme: s => s.theme,
        themes: s => s.themes,
        backgroundColor: s => s.backgroundColor,
        backgrounds: s => s.backgrounds,
        activitiesSelectedBoard: s => s.activitiesSelectedBoard,
        isRecording: s => s.isRecording,
        planLimit: s => s.planLimit,
        billingPlans: s => s.billingPlans,
        importCSVTasks: s => s.importCSVTasks,
        smartListTasks: s => s.smartListTasks,
        timeTrackerTasks: s => s.timeTrackerTasks,
        activitiesTasks: s => s.activitiesTasks
    }
});

export default store;
